import dayjs from "dayjs";

const datePickerValueFormatter = (value: unknown) => {
    if (!value) {
        return null;
    }
    return dayjs(value as Date);
};

export default datePickerValueFormatter;
